import { useCallback, useState } from "react";
import { type ExpandedImagePreview } from "./ExpandedImagePreview";

export function useChatImagePreviewState() {
  const [expandedImage, setExpandedImage] = useState<ExpandedImagePreview | null>(null);
  const closeExpandedImage = useCallback(() => {
    setExpandedImage(null);
  }, []);
  const onExpandTimelineImage = useCallback((preview: ExpandedImagePreview) => {
    setExpandedImage(preview);
  }, []);

  return {
    expandedImage,
    setExpandedImage,
    closeExpandedImage,
    onExpandTimelineImage,
  };
}
